import { TemplateKey } from "PFApp/constants/templates";
import { useTemplateFind } from "PFApp/hooks";
import { SelectV2 } from "PFComponents/select_v2";
import { useCurrentAccount } from "PFCore/hooks/queries/account";
import { fetchActivitiesOptions } from "PFCore/services/activities";
import { ActivityOption, Id } from "PFCore/types";
import { Option } from "PFTypes/options";

type ActivitySelectProps = {
  label: string;
  activity?: ActivityOption;
  onChange: (activity: Option<ActivityOption>) => void;
  onClear?: () => void;
  templateKeys: TemplateKey[];
  parentActivityId?: Id;
  disabled?: boolean;
};

export const ActivitySelect = ({
  label,
  activity,
  onChange,
  onClear,
  templateKeys,
  parentActivityId,
  disabled
}: ActivitySelectProps) => {
  const {
    data: {
      config: {
        minimum_search_term_length: { activities: minimumSearchTermLength }
      }
    }
  } = useCurrentAccount();
  const findTemplate = useTemplateFind();

  const filteredTemplateKeys = templateKeys.filter((templateKey) => !!findTemplate({ key: templateKey }));

  return (
    <SelectV2<ActivityOption>
      label={label}
      value={activity?.id}
      onChange={onChange}
      onClear={onClear}
      renderDisplayValue={() => activity?.name}
      cacheTime={0}
      disabled={disabled}
      fetchOptions={async ({ searchTerm }) => {
        if (!searchTerm || searchTerm.length < minimumSearchTermLength) {
          return { entries: [], meta: { total: 0 } };
        }

        const response = await fetchActivitiesOptions({
          term: searchTerm || "",
          templateKey: filteredTemplateKeys,
          activitiesWithNotifications: true,
          parentActivityId
        });

        return {
          ...response,
          entries: response.entries.map((activityOption) => ({
            id: activityOption.id,
            value: activityOption.name,
            displayElement: activityOption.name,
            original: activityOption
          }))
        };
      }}
    />
  );
};
